(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hatitude-campaign-gallery"] && !Shopify.designMode) return;
  try {
    function setupHatitudeCampaignGalleries(){
 document.querySelectorAll('[data-rv-campaign-gallery]').forEach(gallery=>{
  if(gallery.dataset.ready)return;
  gallery.dataset.ready='true';
  const track=gallery.querySelector('.rv-campaign-track');
  const buttons=[...gallery.querySelectorAll('[data-rv-select]')];
  const select=index=>track.scrollTo({left:track.clientWidth*index,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  buttons.forEach((button,index)=>button.addEventListener('click',()=>select(index)));
  track.addEventListener('scroll',()=>{const index=Math.round(track.scrollLeft/track.clientWidth);buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));},{passive:true});
  track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();const current=Math.round(track.scrollLeft/track.clientWidth);select(Math.max(0,Math.min(buttons.length-1,current+(event.key==='ArrowRight'?1:-1))));}});
 });
}
setupHatitudeCampaignGalleries();
document.addEventListener('shopify:section:load',setupHatitudeCampaignGalleries);
  } catch(e) { console.error(e); }
})();

})();
